<div class="container">
  <div class="top-bar">
    <div class="left">
      <div class="title">Notifications</div>
    </div>
    <div class="right">
      @if(tabIndex$.value === 1 && generalList.length > 0) {
      <p class="mark" (click)="readAll()">Mark all as read</p>
      }
      <div class="close">
        <cs-icon-button iconType="icon" icon="fi-x" size="12" color="secondary" (buttonClick)="close()">
        </cs-icon-button>
      </div>
    </div>
  </div>
  <div class="content">
    <cs-tab
      [tabs]="['Promotions', 'General']"
      padding="sm"
      width="full"
      [selectedIndex]="tabIndex$.value"
      (tabChange)="onTabChanged($event)"
    ></cs-tab>
    <div class="notifications" [appLoading]="loading">
      @switch (tabIndex$.value) { @case (0) { @if(tournamentList.length > 0 || promotionList.length > 0) { @for(item of
      tournamentList;track $index) {
      <div class="notification">
        <div class="img" [style.backgroundImage]="'url(' + (item.listImage.web || '') + ')'"></div>
        <p class="title">{{ item.activityName }}</p>
        <p class="detail" *ngIf="item.activitySubName">{{ item.activitySubName }}</p>
        @switch (item.status) { @case ('startDto') {
        <p class="date">Finishes on {{ item.tmpEndTime | date:'YYYY-MM-dd HH:mm:ss' }}</p>
        } @case ('preDto') {
        <p class="date">Starts on {{ item.tmpStartTime | date:'YYYY-MM-dd HH:mm:ss' }}</p>
        } @case ('endDto') {
        <p class="date">Ended on {{ item.tmpEndTime | date:'YYYY-MM-dd HH:mm:ss' }}</p>
        } }
        <cs-button class="btn" color="primary" label="See more" (buttonClick)="onTournamentClick(item)"></cs-button>
      </div>
      } @for(item of promotionList;track $index) {
      <div class="notification">
        <div class="img" [style.backgroundImage]="'url(' + item.activityImgUrl + ')'"></div>
        <p class="title">{{ item.title }}</p>
        <p class="detail" *ngIf="item.introduction">{{ item.introduction }}</p>
        <p class="date">{{ item.endTime |date:'YYYY-MM-dd hh:mm:ss'}}</p>
        <cs-button class="btn" color="primary" label="See more" (buttonClick)="onPromitionClick(item)"></cs-button>
      </div>
      } }@else{
      <app-empty
        [title]="'No Promotions Right Now'"
        [message]="'Stay tuned — new promotions are on the way!'"
      ></app-empty>
      } } @case (1) { @if(generalList.length > 0) { @for(item of generalList;track $index) {
      <div class="notification">
        <p class="title">{{ item.title }}</p>
        <p class="detail" [innerHTML]="item.content"></p>
        <p class="date">{{ item.sendTime }}</p>
        <cs-icon-button
          class="eye"
          [class.has-unread-dot]="!item.isReaded"
          iconType="icon"
          icon="fi-eye"
          size="32"
          iconFontSize="13"
          color="processes"
          [hasFrame]="true"
          (buttonClick)="onReadClick(item)"
        ></cs-icon-button>
        @if(item.noticeType === 'Transaction' && item.businessType !== "WithdrawalRejected" ) {
        <cs-button class="btn" color="accent" label="Open Wallet" (buttonClick)="onGeneralWalletClick()"></cs-button>
        }@else{
        <cs-button class="btn" color="primary" label="See more" (buttonClick)="onGeneralClick(item)"></cs-button>
        }
      </div>
      } }@else{
      <app-empty [title]="'All Caught Up 🎉'" [message]="'You don\'t have any notifications right now'"></app-empty>
      } } }
    </div>
  </div>
</div>
